/**
 * Mount an SDK-managed preview for an external MediaStream.
 *
 * External canvas-backed streams are rendered directly instead of relying on
 * the RTC engine's local player. This keeps `render.localContainer` reliable
 * on browsers where the RTC renderer cannot preview an external canvas track.
 */
export function mountLocalStreamPreview(
  container: HTMLElement,
  stream: MediaStream,
  fit: 'cover' | 'contain',
): () => void {
  const video = document.createElement('video')
  video.autoplay = true
  video.muted = true
  video.playsInline = true
  video.style.display = 'block'
  video.style.width = '100%'
  video.style.height = '100%'
  video.style.objectFit = fit
  video.style.objectPosition = 'center'
  video.setAttribute('playsinline', 'true')
  video.setAttribute('aria-hidden', 'true')
  video.srcObject = stream

  container.replaceChildren(video)
  void video.play().catch(() => undefined)

  return () => {
    try {
      video.pause()
      if (video.srcObject === stream) {
        video.srcObject = null
      }
    } catch {
    }
    video.remove()
  }
}
